import { render, staticRenderFns } from "./selectProductItem.vue?vue&type=template&id=f082ffc6&scoped=true&"
import script from "./selectProductItem.vue?vue&type=script&lang=js&"
export * from "./selectProductItem.vue?vue&type=script&lang=js&"
import style0 from "./selectProductItem.vue?vue&type=style&index=0&id=f082ffc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082ffc6",
  null
  
)

export default component.exports